<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    :viewBox="viewBox"
    fill="none"
  >
    <path
      d="M6 7.83334H4.66667V9.16667H6V7.83334ZM8.66667 7.83334H7.33333V9.16667H8.66667V7.83334ZM11.3333 7.83334H10V9.16667H11.3333V7.83334ZM12.6667 3.16667H12V1.83334H10.6667V3.16667H5.33333V1.83334H4V3.16667H3.33333C2.59333 3.16667 2 3.76667 2 4.5V13.8333C2 14.187 2.14048 14.5261 2.39052 14.7761C2.64057 15.0262 2.97971 15.1667 3.33333 15.1667H12.6667C13.0203 15.1667 13.3594 15.0262 13.6095 14.7761C13.8595 14.5261 14 14.187 14 13.8333V4.5C14 4.14638 13.8595 3.80724 13.6095 3.55719C13.3594 3.30714 13.0203 3.16667 12.6667 3.16667ZM12.6667 13.8333H3.33333V6.5H12.6667V13.8333Z"
      :fill="fill"
    />
  </svg>
</template>

<script>
export default {
  props: {
    viewBox: { type: String, default: "0 0 16 17" },
    width: { type: [Number, String], default: 16 },
    height: { type: [Number, String], default: 17 },
    iconName: { type: String, default: "icon" },
    fill: { type: String, default: "#666666" },
  },
};
</script>
